import { render, staticRenderFns } from "./TreadDetail.vue?vue&type=template&id=489a00c2&scoped=true&"
import script from "./TreadDetail.vue?vue&type=script&lang=js&"
export * from "./TreadDetail.vue?vue&type=script&lang=js&"
import style0 from "./TreadDetail.vue?vue&type=style&index=0&id=489a00c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a00c2",
  null
  
)

export default component.exports